import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import { Loader2 } from 'lucide-react';
import * as React from 'react';
import { cn } from '../../../lib/utils';
const buttonVariants = cva('inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0', {
    variants: {
        variant: {
            default: 'bg-primary text-primary-foreground hover:bg-primary/90',
            destructive: 'bg-destructive text-destructive-foreground hover:bg-destructive/90',
            outline: 'border border-input bg-background hover:bg-accent hover:text-accent-foreground',
            secondary: 'bg-secondary text-secondary-foreground hover:bg-secondary/80',
            ghost: 'hover:bg-accent hover:text-accent-foreground',
            link: 'text-primary underline-offset-4 hover:underline'
        },
        size: {
            default: 'h-10 px-4 py-2',
            sm: 'h-9 rounded-md px-3',
            lg: 'h-11 rounded-md px-8',
            icon: 'h-10 w-10'
        }
    },
    defaultVariants: {
        variant: 'default',
        size: 'default'
    }
});
const Button = /*#__PURE__*/ React.forwardRef(({ className, variant, size, asChild = false, isLoading = false, children, disabled, ...props }, ref)=>{
    const Comp = asChild ? Slot : 'button';
    return /*#__PURE__*/ _jsxs(Comp, {
        className: cn(buttonVariants({
            variant,
            size
        }), isLoading && 'relative', className),
        ref: ref,
        disabled: disabled || isLoading,
        ...props,
        children: [
            children,
            isLoading && /*#__PURE__*/ _jsx("span", {
                className: "animate-spin absolute right-4",
                children: /*#__PURE__*/ _jsx(Loader2, {
                    className: "h-4 w-4"
                })
            })
        ]
    });
});
Button.displayName = 'Button';
export { Button, buttonVariants };
